<template>
  <div class="aone-amap-container">
    <div style="padding: 10px">
      <span style="font-size: 14px">当前位置: 经度：
        <el-input-number v-model="location[0]" :precision="8" :step="0.1" style="width: 200px"></el-input-number>
        纬度:
        <el-input-number v-model="location[1]" :precision="8" style="width: 200px" :step="0.1"></el-input-number>
      </span><span style="margin-left: 15px"><el-button type="primary" size="small"
          @click="handleSubmit">确认</el-button></span>
      <div id="pickerBox" class="seachBox">
        <input ref="poiInput" class="searchInput" placeholder="输入关键字选取地点" />
      </div>
    </div>
    <div class="aone-amap"></div>
  </div>
</template>

<script>
import { v4 as uuidv4 } from "uuid";
export default {
  props: ["longitude", "latitude"],
  name: "amap",
  watch: {
     longitude(val) {
      this.location = [val, this.latitude];
      this.update();
    },
    latitude(val) {
      this.location = [this.longitude, val],
      this.update();
    },
    location(val) {
      this.update();
    },
  },
  mounted() {
    this.createMap();
  },
  data() {
    return {
      location: [this.longitude, this.latitude],
      drawerShow: false,
      selPosition: {},
      inputId:uuidv4()
    };
  },
  destroyed() {
    this.$amap && this.$amap.destroy();
  },
  methods: {
    createMap() {
      let mapEl = this.$el.querySelector(".aone-amap");
      const elementId = uuidv4();
      mapEl.id = elementId;
      this.$amap = new AMap.Map(elementId, {
        resizeEnable: true,
        zoom: 17,
      });

      this.update();

      AMapUI.loadUI(["misc/PoiPicker"], (PoiPicker) => {
        var poiPicker = new PoiPicker({
          input: this.$refs.poiInput ,
        });

        poiPickerReady(poiPicker);
      });

      const poiPickerReady = (poiPicker) => {
        poiPicker.on("poiPicked", (poiResult) => {
          const poi = poiResult.item;
          this.location = [poi.location.lng, poi.location.lat];
          
          this.selPosition = {...poi};
          this.update();
        });
      };
    },
    update() {
      if (this.location[0] != undefined && this.location[1] != undefined) {
        const marker = new AMap.Marker({
          map: this.$amap,
          position: this.location,
          draggable: true,
          bubble: true,
          topWhenClick: true,
        });

        marker.on("dragend", (e) => {
          console.log("e", e.target.getPosition());
          const pos = e.target.getPosition();
          console.log(e, pos, pos.lng, pos.lat);
          this.location = [pos.lng, pos.lat];
        });

        // 添加marker
        this.$amap.clearMap();
        this.$amap.add(marker);
        this.$amap.setZoomAndCenter(17, this.location);
      } else {
        //如果没有坐标获取地图的中心店添加marker
        const center = this.$amap.getCenter();

        const marker = new AMap.Marker({
          map: this.$amap,
          position: center,
          draggable: true,
          bubble: true,
          topWhenClick: true,
        });

        this.$amap.setZoomAndCenter(17, center);

        marker.on("dragend", (e) => {
          console.log("e", e.target.getPosition());
          const pos = e.target.getPosition();
          console.log(e, pos, pos.lng, pos.lat);
          this.location = [pos.lng, pos.lat];
        });

        this.$amap.clearMap();
        this.$amap.add(marker);
      }
    },
    handleSubmit() {
      this.$emit("change", this.location, this.selPosition);
      this.$emit("close");
    },
  },
};
</script>
<style scoped>
.aone-amap-container {
  width: 100%;
  height: 100vh;
}

.aone-amap {
  height: 600px;
  border: 1px solid #ccc;
  margin: 5px;
}

.seachBox {
  position: absolute;
  z-index: 10000;
  top: 140px;
  font-size: 14px;
}

.searchInput {
  padding: 5px;
  border: 2px solid #ccc;
  border-radius: 5px;
  width: 300px;
}
</style>
